<div
  class="oms-glass-background"
  [ngClass]="customClass"
  [style.padding-top.px]="paddingTop"
  [style.padding-bottom.px]="paddingBottom"
  [style.padding-left.px]="paddingX"
  [style.padding-right.px]="paddingX"
  [style.border-radius.px]="borderRadius"
  [style.--background-opacity]="backgroundOpacity"
>
  <ng-content></ng-content>
</div>
